import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
import { LeafWatermark } from './SectionDivider';
export function IntroSection() {
  return <section className="py-20 md:py-32 bg-brand-black relative overflow-hidden" data-id="element-137">
      {/* Large Leaf Watermark */}
      <LeafWatermark className="absolute -right-20 top-10 w-96 h-96 text-brand-gold opacity-[0.03] rotate-45 pointer-events-none" data-id="element-138" />
      <LeafWatermark className="absolute -left-20 bottom-10 w-64 h-64 text-brand-gold opacity-[0.03] -rotate-45 pointer-events-none" data-id="element-139" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-141">
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-142">
            <Leaf className="text-brand-gold opacity-40" size={24} data-id="element-143" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-gold leading-tight m-0" data-id="element-144">
              Imagine pulling into your driveway and smiling.
            </h2>
            <Leaf className="text-brand-gold opacity-40 -scale-x-100" size={24} data-id="element-145" />
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed font-light" data-id="element-146">
            <p data-id="element-147">
              The grass is perfectly cut. The flower beds are full of color. The
              edges are crisp, the mulch is fresh, and everything just looks...
              exactly the way you always pictured it.
            </p>
            <p data-id="element-148">
              Your kids are playing in a clean, beautiful yard. Your neighbors
              slow down as they walk by. And you? You're sitting on your patio —
              relaxed, proud, and not lifting a single finger.
            </p>
            <p className="font-medium text-brand-gold text-xl md:text-2xl pt-4" data-id="element-149">
              That's not a dream. That's what EITHAN Landscaping & Junk Removal
              delivers — every single visit.
            </p>
          </div>
        </motion.div>

        {/* Before & After Photo */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-16" data-id="element-150">
          <div className="rounded-2xl overflow-hidden border-2 border-brand-gold/30 shadow-2xl shadow-brand-gold/10" data-id="element-151">
            <img src="https://cdn.magicpatterns.com/uploads/prFivAef9jmi2cwiGNw1mA/junk3.png" alt="Before and after junk removal and landscaping transformation by EITHAN" className="w-full h-auto" data-id="element-152" />
          </div>
          <p className="text-center text-brand-gold/60 text-sm mt-4 font-medium tracking-wider uppercase" data-id="element-153">
            Real results — Junk Removal & Landscaping by EITHAN
          </p>
        </motion.div>
      </div>
    </section>;
}